import React from "react";

// core components
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { bindActionCreators }  from 'redux';
import queryString from 'query-string';
import uniqBy from 'lodash/uniqBy';

import { withoutAuth, withSearch } from 'HOC';

import { url } from 'utils';

import { search } from 'api/actions';

import TruncateLine from 'components/TruncateLine';

import MainView from './MainView';

import {
  SEARCH,
  SEARCH_SUCCESS,
  SEARCH_FAILURE
} from 'constants/ActionTypes';


class Search extends React.Component {
  state = {
    selections: [],
    search: null,
    page: 0
  };

  componentWillMount() {
    const q = url.getParam(this.props, 'q');

    this.props.search({ q });
  }

  async componentWillReceiveProps(nextProps) {
    const refresh = this.state.search !== nextProps.location.search;

    const newState = { refresh };

    let cb = () => null;

    switch (nextProps.type) {
      case SEARCH:
        newState.loading = true;
        break;

      case SEARCH_SUCCESS:
        newState.loading = false;

        await this.addObjects(nextProps.objects);
        break;
      case SEARCH_FAILURE:
        newState.loading = false;
        break;
    }

    if (refresh) {
      newState.data = [];
      newState.search = nextProps.location.search;
      newState.page = 0;

      cb = () => this.fetchMore();
    }

    this.setState(newState, cb);
  }

  fetchMore = () => {
    const { loading, page } = this.state;

    if (!loading) {
      const q = url.getParam(this.props, 'q');

      this.props.search({ page, q });

      this.setState({
        page: page + 1
      });
    }
  }

   addObjects = (objects = []) => new Promise((resolve) => {
    if (objects.length > 0) {
      let objs = this.state.data;

      objs = objs.concat(objects);
      objs = uniqBy(objs, info => info.id);

      this.setState({
        data: objs,
      }, resolve);
    } else {
      resolve();
    }
  });


  render() {
    return (
      <MainView
        {...this.props}
        data={this.state.data}
        loading={this.state.loading}
        fetchMore={this.fetchMore}
        refresh={this.state.refresh}
        emptyTitle='No results found'
      />
    );
  }
}

const mapStateToProps = (state) => ({
  errorMessage: state.errorMessage,
  objects: state.objects,
  type: state.type,
});

const dispatchToProps = (dispatch) => {
  return bindActionCreators({ search }, dispatch)
};


export default connect(mapStateToProps, dispatchToProps)(
  Search
)
